module.exports = __webpack_public_path__ + "d2abac77cc0467a04ae3562273e19f92.pdf";